import { subDays, format } from "date-fns";

export default function getWeekPeriod(endPeriod, period = 7) {
  const endDate = endPeriod;
  const startDate = subDays(endDate, period);
  const formattedStartDate = format(startDate, "MM/dd/yyyy");
  const formattedEndDate = format(endDate, "MM/dd/yyyy");

  return {
    formattedStartDate,
    formattedEndDate,
    startDate,
    endDate
  };
}
